import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'material-ui/Form';

import Icon from 'material-ui/Icon';
import { withStyles } from 'material-ui/styles';

const styles = theme => ({
  withIcon: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  withMargin: {
    marginRight: theme.spacing.unit * 2,
  },
});

const CheckboxWidget = props => {
  const { classes, value } = props;
  const displayValue = value ? 'Kyllä' : 'Ei';
  const icon = value ? 'done' : 'clear';
  return (
    <FormControl margin="normal" fullWidth className={classes.withIcon}>
      <Icon className={classes.withMargin}>{icon}</Icon>
      {displayValue}
    </FormControl>
  );
};

CheckboxWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.any,
};

export default withStyles(styles)(CheckboxWidget);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/readonly/CheckboxWidget.js